import useModal from "../../useModal";
import UseContext from "../../../../hooks/useContext";
import Modalheader from "../../components/header";
import ModalBody from "../../components/body";
import ModalFooter from "../../components/footer";
import Button from "../../../../components/button";
import SubmitButton from "../../../../components/button/SubmitButton";
import CsvDropzone from "../../../../components/csvImport/CsvDropzone";
import { Export } from "../../../../assets/icons";
import React, { useState, useMemo } from "react";
import ApiDatabase from "../../../../server";

const extractCsvNames = (rows) => {
  const names = new Set();
  for (const row of rows) {
    if (Array.isArray(row)) {
      for (const cell of row) {
        const value = String(cell || "").trim();
        if (value) names.add(value);
      }
    } else if (row && typeof row === "object") {
      for (const value of Object.values(row)) {
        const trimmed = String(value || "").trim();
        if (trimmed) names.add(trimmed);
      }
    }
  }
  return Array.from(names);
};

const ModalCreateQualificationImport = () => {
  const { toggle } = useModal();
  const { modalData } = UseContext();
  const [csvNames, setCsvNames] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const onSuccess = modalData?.onSuccess;

  const canSubmit = useMemo(() => csvNames.length > 0, [csvNames]);

  const downloadTemplate = () => {
    const exampleNames = [
      "Manutentionnaire",
      "Chef d'équipe",
      "Cariste",
      "Monteur",
      "Ouvrier",
    ];
    const csvContent = "name\n" + exampleNames.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "template_postes.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleSubmit = () => {
    if (csvNames.length === 0) return;
    setSubmitting(true);
    ApiDatabase.postCreateQualificationsBulk(
      { names: csvNames },
      () => {
        setSubmitting(false);
        if (onSuccess) onSuccess();
        toggle();
      },
      () => setSubmitting(false)
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Importer des postes
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-4">
          {/* Section 1 : Télécharger la template */}
          <div className="rounded-lg border p-4">
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="font-semibold text-gray-900">
                  1. Téléchargez la template
                </div>
                <p className="mt-1 ft-sm text-gray-600">
                  Utilisez ce modèle avec les templates déjà définies pour ajouter des postes
                </p>
              </div>
              <Button color="SECONDARY" size="SM" onClick={downloadTemplate}>
                <div className="flex items-center gap-1">
                  <Export wh={20} color="#374151" />
                  Télécharger
                </div>
              </Button>
            </div>
          </div>

          {/* Section 2 : Importer le CSV */}
          <div className="rounded-lg border p-4">
            <div className="font-semibold text-gray-900">2. Importer le CSV</div>
            <p className="mt-1 ft-sm text-gray-600">
              Une fois rempli, ajoutez le ici
            </p>
            <div className="mt-3">
              <CsvDropzone
                papaParseConfig={{ skipEmptyLines: true, header: false }}
                onParsed={(rows) => setCsvNames(extractCsvNames(rows))}
                onError={() => setCsvNames([])}
                dropzoneLabel="Importer un fichier ou glisser-déposer. CSV jusqu'à 1MB."
              />
            </div>
            {csvNames.length > 0 && (
              <div className="mt-3 ft-sm text-gray-700">
                {csvNames.length} poste{csvNames.length > 1 ? "s" : ""} détecté
                {csvNames.length > 1 ? "s" : ""}.
              </div>
            )}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="SECONDARY" size="LG" onClick={toggle}>
          Annuler
        </Button>
        <SubmitButton
          loading={submitting}
          onClick={handleSubmit}
          disabled={!canSubmit}
        />
      </ModalFooter>
    </>
  );
};

export default ModalCreateQualificationImport;
